module.exports = __webpack_public_path__ + "img/xiaomi-redmi-note9-pro.ed26f0c8.png";